import styled from "styled-components";
import { BodyDefault, HeadLine3 } from "../../../../components/typography/styled";
export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  font-family: 'InterVariable', 'Inter', sans-serif;
  margin-top:20px;
  background-color: ${({theme}) => theme.base.white};
  min-height: 240px;
  gap:10px;
`

export const NavItem = styled.div`
  box-sizing: border-box;
  background: ${({theme}) => theme.palette[100]};
  border-radius: 14px;
  box-shadow: ${({theme}) => theme.isDark
    ? theme.shadows.card
    : '0px 4px 30px rgba(186, 196, 211, 0.2)'};
  min-height: 240px;
  padding: 20px;
  display: flex;
  /* z-index: 3; */
  overflow: hidden;
  flex-direction: column;
  position: relative;
  /* justify-content: space-between; */
  flex: 1 1 220px;
  min-width: 0;

  &:nth-child(n + 3) h3 {
    margin-bottom: 6px;
  }

  &:nth-child(2) > img:last-child {
    left: 0.5px;
    bottom: -44px;
    width: 140px;
    height: 140px;
  }

  &:nth-child(3) > img:last-child {
    left: 10px;
    bottom: -39px;
  }

  &:nth-child(4) > img:last-child {
    left: 20.5px;
    bottom: -25px;
    width: 114px;
    height: 114px;
  }

  &:hover {
    cursor: pointer;
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[200]};
  }
  &:active{
    background-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.grey[300]};
    transition: 0.1s background-color ease-in-out;
  }

  @media screen and (max-width: 600px) {
    flex-basis: 100%;
    min-width: 100%;
  }
`
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  z-index: 1;
`
export const NavTitle = styled(HeadLine3)`
  color:${({theme}) => theme.neutral[100]};
  margin-bottom:8px;
  transform: translateY(1px);
`

export const NavDesc = styled(BodyDefault)`
  color:${({theme}) => theme.neutral[80]};
  margin-bottom:0;
  overflow-wrap: anywhere;
`


export const CreateWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  margin-top: 8px;
`

export const IconCreate = styled.img`
  width:20px;
  height:20px;
  margin-right:8px;
`

export const CreateLink = styled(BodyDefault)`
  color:${({theme}) => theme.icon.primary};
  overflow-wrap: anywhere;
`
export const BackgroundIcon = styled.img`
  position: absolute;
  left: 10px;
  bottom: -34px;
  width: 134px;
  height: 134px;
`
